import React, { useState } from "react";
import { useSelector } from "react-redux";

function MainHeader() {
	// const [showEmergency, setShowEmergency] = useState(false);
	// const { isLogin, user } = useSelector((state) => state.login);
	const [open, setOpen] = useState(false);
	const toggleMobileMenu = () => {
		setOpen(!open);
	};
	return (
		<>
			{/* <TopHeader /> */}
			<header id="header" class={open ? `header d-flex align-items-center mobile-nav-active` : `header d-flex align-items-center`}>
				<div class="container-fluid container-xl d-flex align-items-center justify-content-between">
					<p to="/" className="logo d-flex align-items-center">
						<img src='/image/Logo_Hospital.png' alt="" />
					</p>

					<nav id="navbar" class="navbar">
						<ul>
							<li><p to="/">Home</p></li>
							<li><p to="/about">About Us</p></li>
							<li><p to="/service">Our Services</p></li>
							<li><p to="/e-clinic-register">Franchise/E-Clinic Request</p></li>
							<li>
								<p to="/career">Career</p>
							</li>
							<button
								style={{
									borderRadius: "26px",
									padding: "10px",
									marginLeft: "40px",
								}}
								className="call-emergency-numbe btn btn-info"
							>
								<a
									href="tel:6262808062"
									style={{ color: "white" }}
								// onClick={(e) => setShowEmergency(true)}
								>
									<i className="fa fa-phone"></i> &nbsp;6262-8080-62
								</a>
							</button>
						</ul>
					</nav>
					<i class={open ? "mobile-nav-toggle mobile-nav-show bi bi-list d-none" : "mobile-nav-toggle mobile-nav-show bi bi-list"} onClick={toggleMobileMenu}></i>
					<i class={open ? "mobile-nav-toggle mobile-nav-hide bi bi-x" : "mobile-nav-toggle mobile-nav-hide d-none bi bi-x"} onClick={toggleMobileMenu}></i>
				</div>
			</header>
		</>
	);
}

export default MainHeader;